const Config = {
    'jwtStorageKey': 'jwt-biiu-a8sdf2u3r2a',
    'SaltBefore': 'dsa8',
    'SaltAfter': 'cx8ew'
}

export default Config
